<script setup>
import { computed } from 'vue'
import { i18n, setLocale } from '../i18n'

// Create a v-model friendly proxy so we reuse central setLocale (persists + lazy loads)
const localeModel = computed({
  get: () => i18n.global.locale.value,
  set: (val) => setLocale(val)
})
</script>
<template>
  <label for="language-select" class="sr-only">{{ i18n.global.t('lang.select') }}</label>
  <select
    id="language-select"
    v-model="localeModel"
    class="lang-select"
    :aria-label="i18n.global.t('lang.select')"
  >
    <option value="el">{{ i18n.global.t('lang.el') }}</option>
    <option value="en">{{ i18n.global.t('lang.en') }}</option>
  </select>
</template>

<style scoped>
/* Screen reader only class for accessible label */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.lang-select {
  padding: 0.5rem 2rem 0.5rem 0.7rem;
  min-height: 44px; /* Minimum touch target size */
  font-size: 0.8rem;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.2);
  color: #ddd;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s var(--ease);
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23e07e27' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.6rem center;
  background-size: 10px;
  font-family: var(--font, 'Inter', sans-serif);
  letter-spacing: 0.3px;
  -webkit-tap-highlight-color: transparent;
}

.lang-select:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(224, 126, 39, 0.4);
}

.lang-select:focus {
  outline: 2px solid rgba(224, 126, 39, 0.4);
  outline-offset: 2px;
  border-color: var(--accent);
}

.lang-select option {
  background: var(--inner);
  color: #ddd;
  padding: 1rem 0.75rem;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.lang-select option:checked {
  background: linear-gradient(135deg, rgba(224, 126, 39, 0.25), rgba(224, 126, 39, 0.15));
  color: var(--accent);
  font-weight: 600;
}

.lang-select option:hover {
  background: rgba(224, 126, 39, 0.2);
  color: #fff;
}

@media (max-width: 768px) {
  .lang-select {
    min-height: 44px;
  }

  .lang-select option {
    padding: 1.2rem 1rem;
    font-size: 1.1rem;
  }
}
</style>
